import { Controller } from "@hotwired/stimulus"

// Warns (without blocking) when a payment amount exceeds the balance due.
// Usage:
//   <form data-controller="balance-warning" data-balance-warning-balance-value="5000">
//     <input data-action="input->balance-warning#check">
//     <p data-balance-warning-target="warning" class="hidden">…</p>
//   </form>
export default class extends Controller {
  static targets = ["warning"]
  static values = { balance: Number }

  check(event) {
    const amount = parseFloat(event.target.value) || 0
    this.warningTarget.classList.toggle("hidden", amount <= this.balanceValue)
  }
}
